import { create } from "zustand";

import type { ToolbarItem } from "components/lib/EntityHeader";

type EditToolbarStore = {
  /** How many area toolbars show the page's edit controls. */
  hosts: number;
  /** How many edit toolbars are showing, so the host can hide its defaults. */
  active: number;
  /** Each edit toolbar's controls, for the host to show. */
  items: Record<string, ToolbarItem[]>;
};

export const useEditToolbarStore = create<EditToolbarStore>(() => ({
  hosts: 0,
  active: 0,
  items: {},
}));

/** Whether the page shows an `EditToolbar`, so its area can hide what's in the way. */
export const useIsEditing = () =>
  useEditToolbarStore((state) => state.active > 0);
